
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XButton,
XHeader
},
data () {
return {



}
},
created() {

},
mounted(){

},
methods:{
setTime(){
let nTime = 8;
let iTime = setInterval(function() {
nTime--;
if (nTime <= 0) {
clearInterval(iTime);
this.acceptTxt = '我已阅读并同意';
this.readed = true;
} else {
this.readed = false;
this.acceptTxt = '我已阅读并同意(' + nTime + 's)';
}
}.bind(this), 1000);
},
alreadyRead(){
this.$vux.alert.show({
title: "补充接口",
content: "最好补充一个已阅读的接口，点击后以后再提醒阅读",
})
},

}
}



// WEBPACK FOOTER //
// ./src/pages/taxState.vue